export default class DialogHandler {
    constructor(dialog) {
        this.dialog = dialog;
        this.init();
    }

    init() {
        this.dialog.querySelector('.js-dialog-close').addEventListener('click', () => this.closeDialog());
    }

    openDialog() {
        this.dialog.showModal();
    }

    closeDialog() {
        this.dialog.close();
    }
}
